export enum Persona {
  Developer = 'developer',
  Founder = 'founder',
  Maker = 'maker',
}

export default Persona;
